import mixins from 'vue-typed-mixins';

import { E取込分類, E取込形式 } from '@/openapi/enum';

import C取込データ選択Dialog from '@/components/取込/データ選択/取込データ選択Dialog.vue';
import Pdf決算書Dialog from '@/components/取込/データ確認/pdf/決算書/Pdf決算書Dialog.vue';
import Pdf固定資産台帳Dialog from '@/components/取込/データ確認/pdf/固定資産台帳/Pdf固定資産台帳Dialog.vue';
import Pdf試算表Dialog from '@/components/取込/データ確認/pdf/試算表/Pdf試算表Dialog.vue';
import Xlsxデータ確認Dialog from '@/components/取込/データ確認/xlsx/Xlsxデータ確認Dialog.vue';

import 取込Mixin from '@/entries/user/mixins/取込Mixin';

export default mixins(取込Mixin).extend({
  name: 'M取込DialogMixin',

  components: {
    C取込データ選択Dialog,
    Pdf決算書Dialog,
    Pdf固定資産台帳Dialog,
    Pdf試算表Dialog,
    Xlsxデータ確認Dialog,
  },

  data(): {
    dialogVisible: {
      データ選択: boolean;
      pdf決算書: boolean;
      pdf固定資産台帳: boolean;
      pdf試算表: boolean;
      xlsxデータ確認: boolean;
    };
  } {
    return {
      dialogVisible: {
        データ選択: false,
        pdf決算書: false,
        pdf固定資産台帳: false,
        pdf試算表: false,
        xlsxデータ確認: false,
      },
    };
  },

  methods: {
    openFirstDialog(): void {
      switch (this.importInfo.取込形式) {
        case E取込形式.pdf:
          this.dialogVisible.データ選択 = true;
          return;
        case E取込形式.xlsx:
          this.dialogVisible.xlsxデータ確認 = true;
          return;
      }
    },
    selectPage(): void {
      this.dialogVisible.データ選択 = false;
      switch (this.importInfo.取込分類) {
        case E取込分類.決算書:
          this.dialogVisible.pdf決算書 = true;
          break;
        case E取込分類.固定資産台帳:
          this.dialogVisible.pdf固定資産台帳 = true;
          break;
        default:
          this.dialogVisible.pdf試算表 = true;
          break;
      }
    },
  },
});
